import React, { Fragment } from 'react'

import styled from 'styled-components'
import WithForcedMonospace from './WithForcedMonospace'

// wrapper for chapter times colors them in gold, silver, or bronze based on passed props
const WithPodiumStyles = ({ children, rank, em }) => {
  if (children == null) return null

  let emProps = {}
  if (em) {
    emProps['em'] = em
  }

  // classnames are just in case they're useful later
  switch(rank) {
    case 1:
      return (
        <FirstPlaceSpan className='podium-styles-wrapper'>
          <WithForcedMonospace {...emProps}>
            {children}
          </WithForcedMonospace>
        </FirstPlaceSpan>
      )
    case 2:
      return (
        <SecondPlaceSpan className='podium-styles-wrapper'>
          <WithForcedMonospace {...emProps}>
            {children}
          </WithForcedMonospace>
        </SecondPlaceSpan>
      )
    case 3:
      return (
        <ThirdPlaceSpan className='podium-styles-wrapper'>
          <WithForcedMonospace {...emProps}>
            {children}
          </WithForcedMonospace>
        </ThirdPlaceSpan>
      )
    default:
      return (
        <NoWrapSpan className='podium-styles-wrapper'>
          <WithForcedMonospace {...emProps}>
            {children}
          </WithForcedMonospace>
        </NoWrapSpan>
      )
  }
}

export default WithPodiumStyles

const NoWrapSpan = styled.span`
  white-space: nowrap;
`

// yes, all the properties being "doubled up" in the CSS below is on purpose
// inside the .monospaced-char selector handles the digits, outside of it handles the colon and decimal point
const GradientSpan = styled(NoWrapSpan)`
  .monospaced-char {
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`

const FirstPlaceSpan = styled(GradientSpan)`
  background-image: var(--gold-gradient);
  .monospaced-char {
    background-image: var(--gold-gradient);
  }
`

const SecondPlaceSpan = styled(GradientSpan)`
  background-image: var(--silver-gradient);
  .monospaced-char {
    background-image: var(--silver-gradient);
  }
`

const ThirdPlaceSpan = styled(GradientSpan)`
  background-image: var(--bronze-gradient);
  .monospaced-char {
    background-image: var(--bronze-gradient);
  }
`

